// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRadiusBottomleftOutlinedSvg from "@fishx/icons-svg/es/asn/PRadiusBottomleftOutlined";
import FishxIcon from '../components/FishxIcon';

var PRadiusBottomleftOutlined = function PRadiusBottomleftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRadiusBottomleftOutlinedSvg
  }));
};

PRadiusBottomleftOutlined.displayName = 'PRadiusBottomleftOutlined';
export default React.forwardRef(PRadiusBottomleftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRadiusBottomleftOutlined.js
// module id = 3574
// module chunks = 0